'use client';

import { ReactNode } from 'react';

import { StatusVariant } from '@web/types';

import { MainButton } from '../atomic-atoms';

export type ActionItem = {
  text: ReactNode;
  ariaLabel?: string;
  variant?: 'primary' | StatusVariant;
  onClick: () => void;
  disabled?: boolean;
  isLoading?: boolean;
};

type ActionItemsProps = {
  items: ActionItem[];
  style?: React.CSSProperties;
};

export function ActionItems({ items, style = {} }: ActionItemsProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        ...style,
      }}
    >
      {items.map((item, idx) => (
        <MainButton
          key={idx}
          variant={item.variant}
          ariaLabel={item.ariaLabel}
          onClick={item.onClick}
          isLoading={item.isLoading}
          disabled={item.disabled}
        >
          {item.text}
        </MainButton>
      ))}
    </div>
  );
}
